import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import Samples from "./Samples";
import SearchIcon from "@mui/icons-material/Search";
import { useRef, useState } from "react";
import { getQNLIResults } from "../../../../api/llm";
import { LLMQNLIResponse } from "../../../../types/llm";
import Results from "./Results";
import Disclaimer from "../Disclaimer";
import TaskInfo from "../TaskInfo";
import PredictingOverlay from "../PredictingOverlay";

interface QNLIProps {
  index: number;
  tabValue: number;
}

const QNLI = (props: QNLIProps): ReactElement => {
  const { tabValue, index } = props;
  const [inputQuestion, setInputQuestion] = useState("");
  const [inputContext, setInputContext] = useState("");
  const [results, setResults] = useState<LLMQNLIResponse | undefined>(
    undefined,
  );
  const [isPredicting, setIsPredicting] = useState(false);
  const isPredictingRef = useRef(false);

  const handleSampleSelected = (question: string, context: string) => {
    setInputQuestion(question);
    setInputContext(context);
  };

  const handleInputSampleClick = () => {
    if (isPredictingRef.current) {
      return;
    }

    isPredictingRef.current = true;
    setIsPredicting(true);
    getQNLIResults(inputQuestion, inputContext)
      .then((response) => {
        console.log(response);
        setResults(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        isPredictingRef.current = false;
        setIsPredicting(false);
      });
  };

  return tabValue === index ? (
    <Container sx={{ marginTop: 5 }} hidden={tabValue !== index}>
      <Disclaimer />
      <TaskInfo
        name="QNLI"
        meaning="Question Natural Language Inference"
        description="QNLI determines whether a sentence contains enough information to answer a given question. The model predicts whether the context entails the answer to the question."
      />
      <Grid container spacing={2} columns={10}>
        <Grid item xs={10} md={6}>
          <Paper
            elevation={2}
            sx={{
              padding: 3,
              border: "1px solid",
              borderColor: "divider",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <PredictingOverlay open={isPredicting} />
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Question"
                placeholder="Write the question"
                id="input-qnli-question-text"
                value={inputQuestion}
                onChange={(e) => setInputQuestion(e.target.value)}
              />
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Context"
                placeholder="Write the sentence that may answer the question"
                id="input-qnli-context-text"
                value={inputContext}
                onChange={(e) => setInputContext(e.target.value)}
              />
              <Button
                variant="contained"
                size="large"
                fullWidth
                startIcon={<SearchIcon />}
                disabled={isPredicting}
                onClick={() => handleInputSampleClick()}
              >
                Analyze entailment
              </Button>
            </Stack>
          </Paper>
          <Container sx={{ marginTop: 2 }}>
            <Results results={results} />
          </Container>
        </Grid>
        <Grid item xs={10} md={4}>
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Examples
            </Typography>
            <Samples sampleSelectedCallback={handleSampleSelected}></Samples>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  ) : (
    <></>
  );
};

export default QNLI;
